import React from "react";
import { BoothSettings } from "./BoothSettings";
import { authHeader } from "../../../../helpers/authHeader";
import { handleResponse } from "../../../../helpers/handleresponse";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { Button, Divider } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { AttachmentSettings } from "./AttachmentSettings";
import { ProfileSettings } from "./ProfileSettings";
import AddIcon from "@material-ui/icons/Add";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { Col, Row } from "reactstrap";

const DEFAULT_BUTTON_STYLE = {
  marginRight: 10,
  boxShadow: "none",
  background: "#eee",
};

export function Settings(props) {
  const {
    exhibitorId,
    deleteList = [],
    settings = [],
    savePersonalSettings = () => null,
    onDelete = () => null,
    onEdit = () => null,
    onAdd = () => null,
    onSave = () => null,
    lang = null,
    page,
    exImage = "",
    exBio = "",
  } = props;

  const [open, setOpen] = React.useState(false);
  const [temp, setTemp] = React.useState(null);
  const [isSavable, setSavable] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [image, setImage] = React.useState(exImage);
  const [bio, setBio] = React.useState(exBio);
  const [personalSettings, setPersonalSettings] = React.useState({});
  const [target, setTarget] = React.useState(null);
  const toggleModal = () => setOpen(!open);

  const setPlaceholderId = () => settings.length * -1;
  const setSortOrder = (type) => {
    if (!settings.find((s) => s.name == type)) return 1;
    return settings.filter((s) => s.name == type).length + 1;
  };

  const add = (type) =>
    onAdd({
      exhibitorSettingId: setPlaceholderId(),
      name: type,
      value: "",
      value2: "",
      updated: new Date(),
      inserted: new Date(),
      sortOrder: setSortOrder(type),
      exhibitorId,
    });
  const onImageSet = (source) => {
    setSavable(true);
    setImage(source);
  };
  const onBioSet = (text) => {
    setSavable(true);
    setBio(text);
  };
  const onUpload = (e, index, type) => {
    const file = e.target.files[0];
    let reader = new FileReader();
    setTarget(index);
    setLoading(true);

    reader.onload = (e) => {
      if (e.target.result) {
        const fileInfo = {
          name: file.name,
          size: file.size,
          type: file.type,
          file: reader.result,
          exhibitor: "Exhibitor/" + exhibitorId,
        };
        const requestOptions = {
          method: "POST",
          headers: authHeader({ "Content-Type": "application/json" }),
          body: JSON.stringify(fileInfo),
        };
        fetch(`./api/files/`, requestOptions)
          .then(handleResponse)
          .then((file) => {
            let path = type == "LogoImage" ? "value" : "value2";
            onEdit(index, path, file.url);
            setTarget(null);
            setLoading(false);
          })
          .catch((err) => {
            console.error(err.message);
          });
      }
    };
    if (file /*  && type == "LogoImage" && file.type.match("image.*") */) {
      reader.readAsDataURL(file);
    }
    setSavable(true);
  };

  const api = {
    ...props,
    open,
    temp,
    isSavable,
    isLoading,
    image,
    bio,
    personalSettings,
    target,
    toggleModal,
    onImageSet,
    onUpload,
    setSavable,
    onBioSet,
    add,
    setSortOrder,
    setPlaceholderId,
  };

  const view = () => {
    switch (page) {
      case "SETTINGS.BOOTH":
        return <BoothSettings {...api} />;
      case "SETTINGS.PROFILE":
        return <ProfileSettings {...api} />;
      case "SETTINGS.ATTACHMENTS":
        return <AttachmentSettings {...api} />;
      default:
        return null;
    }
  };

  const viewTitle = () => {
    switch (page) {
      case "SETTINGS.BOOTH":
        return (
          <div className="expo-view-title">
            <div className="header">
              <EventLabel2 name="BoothSettings" groupName="Exhibitor.Admin" />
            </div>
            <div className="description">
              <EventLabel2
                name="BoothSettingsDesc"
                groupName="Exhibitor.Admin"
              />
            </div>
          </div>
        );
      case "SETTINGS.PROFILE":
        return (
          <div className="expo-view-title">
            <div className="header">
              <EventLabel2
                name="PersonalSettings"
                groupName="Exhibitor.Admin"
              />
            </div>
            <div className="description">
              <EventLabel2
                name="PersonalSettingsDesc"
                groupName="Exhibitor.Admin"
              />
            </div>
          </div>
        );
      case "SETTINGS.ATTACHMENTS":
        return (
          <div className="expo-view-title">
            <div className="header">
              <EventLabel2
                name="AttachmentMaterials"
                groupName="Exhibitor.Admin"
              />
            </div>
            <div className="description">
              <EventLabel2
                name="AttachmentMaterialsSettingsDesc"
                groupName="Exhibitor.Admin"
              />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div style={{ padding: 10, background: "#fff", padding: '15px 24px' }}>
        <Row>
          <Col className="col-6 text-left">{viewTitle()}</Col>
          <Col className="col-6 text-right">
            {page == "SETTINGS.ATTACHMENTS" ? (
              <>
                <Button
                  onClick={() => {
                    add("File");
                    setSavable(true);
                  }}
                  startIcon={<AddIcon />}
                  color={"default"}
                  style={DEFAULT_BUTTON_STYLE}
                >
                  <SystemLabel name="UploadFile" />
                </Button>
                <Button
                  onClick={() => {
                    add("Link");
                    setSavable(true);
                  }}
                  startIcon={<AddIcon />}
                  color={"default"}
                  style={DEFAULT_BUTTON_STYLE}
                >
                  <SystemLabel name="AddLink" />
                </Button>
              </>
            ) : null}
            <Button
              disabled={!isSavable}
              onClick={() => {
                setSavable(false);
                savePersonalSettings(bio, image);
                props.onSave();
              }}
              startIcon={<SaveIcon />}
              color={"primary"}
              variant="contained"
            >
              <SystemLabel name="Save" />
            </Button>
          </Col>
        </Row>
      </div>
      <Divider />
      {view()}
    </div>
  );
}
